<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <form>
          <vue-form-generator :schema="customerPlacesSchema" :model="customerPlacesModel" />
        </form>
      </div>
    </div>
  </div>
</template>

<script>

import VueFormGenerator from 'vue-form-generator'

export default {
  name: 'CustomerCreate',
  components: {
    'vue-form-generator': VueFormGenerator.component
  },
  data () {
    return {
      customerPlacesModel: {},
      customerPlacesSchema: {}
    }
  },
  props: {
    schema: {}
  },
  watch: {
    schema: function (newVal, oldVal) {
      this.customerPlacesSchema = this.$props.schema
      this.appendtoSchema()
    }
  },
  created () {
    this.customerPlacesSchema = this.$route.params.schema
    this.appendtoSchema()
    this.getCustomers()
  },
  methods: {
    appendtoSchema () {
      this.customerPlacesSchema = this.$route.params.schema
      this.customerPlacesSchema.fields.push({
        type: 'submit',
        buttonText: 'Spara',
        onSubmit: this.onSave
      },
      {
        type: 'submit',
        buttonText: 'Avbryt',
        onSubmit: this.onCancel
      })
    },
    getCustomers () {
      this.customerPlacesSchema = this.$route.params.schema
      var customerSelect = this.customerPlacesSchema.fields.find(field => field.model === 'kund')
      this.$http
        .get('/api/customers')
        .then(response => {
          var customers = response.data.customers
          for (var i = 0; i < customers.length; i++) {
            customerSelect.values.push({'id': customers[i].id, 'name': customers[i].data.name})
          }
        })
        .catch(error => console.log(error))
    },
    onSave () {
      var CustomerSelect = document.getElementById('kund')
      var selectedCustomerValue = CustomerSelect.options[CustomerSelect.selectedIndex].value
      var url = '/api/customersplaces'
      this.$http
        .post(url, {
          customerPlace: {
            customerId: selectedCustomerValue,
            ...{
              data: this._.omit(this.customerPlacesModel, 'submit', 'kund')
            }
          }
        })
        .then(response => {
          this.$router.push('/customerPlacesList')
        })
        .catch(error => console.log(error))
    },
    onCancel () {
      this.$router.push('/customerPlacesList')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Customers/CustomerPlacesCreate.vue